import api from './api';

export interface Feriado {
  _id: string;
  nombre: string;
  fecha: string;
  activo: boolean;
}

export interface CreateFeriadoPayload {
  nombre: string;
  fecha: string;
  activo?: boolean;
}

export const getFeriados = (params?: { desde?: string; hasta?: string }) =>
  api.get<Feriado[]>('/feriados', { params });

export const createFeriado = (payload: CreateFeriadoPayload) =>
  api.post<Feriado>('/feriados', payload);

export const updateFeriado = (id: string, payload: Partial<CreateFeriadoPayload>) =>
  api.patch<Feriado>(`/feriados/${id}`, payload);

export const removeFeriado = (id: string) => api.delete(`/feriados/${id}`);
